import { useEffect, useRef } from "react";

/**
 * Adds the `is-visible` class to elements with `.reveal` once they enter the viewport.
 * Lightweight, no external dependency.
 */
export const useReveal = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const scope = rootRef.current || document;
    const els = scope.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return rootRef;
};
